import React from "react";

/**
 * LeaderCard — initials-silhouette leadership card.
 * No portraits. Off-white tile, hairline navy circle with initials,
 * gold hairline rule, title in serif, restrained bio.
 */
export const LeaderCard = ({ initials, title, bio }) => {
  return (
    <article className="flex flex-col">
      <div className="relative aspect-[4/5] w-full bg-offwhite border border-navy/8 flex items-center justify-center">
        <div className="flex flex-col items-center gap-6">
          <div
            aria-hidden="true"
            className="h-24 w-24 rounded-full border border-navy/18 flex items-center justify-center"
          >
            <span className="font-serif text-2xl tracking-[0.04em] text-navy">
              {initials}
            </span>
          </div>
          <span aria-hidden="true" className="block h-px w-10 bg-gold" />
        </div>
      </div>
      <h3 className="mt-6 font-serif text-xl sm:text-2xl leading-tight text-navy">
        {title}
      </h3>
      <p className="mt-4 font-sans text-[14.5px] leading-[1.7] text-navy/70 max-w-[44ch]">
        {bio}
      </p>
    </article>
  );
};

export default LeaderCard;
